import { makeStyles } from '@material-ui/core'
import checkImage from '../../../../assets/svg/check.svg'

export const useStyles = makeStyles((theme) => ({
  '& h1': {
    color: theme.palette.primary.main
  },

  checkControl: {
    display: 'flex',
    gap: '40px',
    marginBottom: '16px',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '10px'
    }
  },

  input: {
    padding: 8,
    borderRadius: 4,
    margin: '8px 0 8px 0',
    width: 'calc(100% - 16px)',
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.paragraph.fontSize,
    border: 'none',

    '&:focus': {
      outline: 'none'
    },
    '&:disabled': {
      opacity: 0.5
    }
  },

  textarea: {
    padding: 8,
    height: 24,
    borderRadius: 4,
    margin: '8px 0 8px 0',
    width: 'calc(100% - 16px)',
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.paragraph.fontSize,
    border: 'none',
    background: `${theme.app.colors.input.background} no-repeat calc(100% - 16px) center`,
    minHeight: '100px',

    '&:focus': {
      outline: 'none'
    },

    '&:disabled': {
      opacity: 0.5
    }
  },

  formControl: {
    position: 'relative',

    '& label': {
      color: theme.app.colors.text.primary,
      fontSize: 14
    }
  },

  '& .select-input__error': {
    top: 67,
    left: 0,
    display: 'block',
    width: '100%',
    position: 'absolute',
    color: theme.app.indication.danger,
    fontSize: theme.app.typography.error.fontSize,

    whiteSpace: 'normal',
    wordBreak: 'break-word'
  },

  buttonWrapper: {
    width: 'auto',
    padding: '8px 16px'
  },

  // checkControl: {
  //   display: 'flex',
  //   gap: '40px',
  //   marginBottom: '16px',

  //   [theme.breakpoints.down('sm')]: {
  //     flexDirection: 'column',
  //     gap: '10px',
  //   }
  // },

  halfWidth: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '10px',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginBottom: 16
    },

    '& .input_text': {
      width: '100%'
    },

    '& .formControl': {
      width: '100%'
    },

    '& button': {
      marginTop: '4px'
    }
  },
  labelTotal: {
    color: '#858585'
  },
  loteList: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    //position: 'absolute',
    top: '31px',
    maxWidth: '700px',
    marginBottom: '16px',

    '& li': {
      background: '#FFFCFC',
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: '10px',
      display: 'inline-block',
      fontSize: '14px',
      lineHeight: '15px',
      padding: '3px 25px 3px 10px',
      position: 'relative',
      marginLeft: '8px'
    }
  },

  remove: {
    transform: 'rotate(45deg)',
    background: 'none',
    border: '0 none',
    fontSize: '18px',
    lineHeight: '20px',
    margin: 0,
    padding: 0,
    position: 'absolute',
    right: '8px',
    top: '1px',
    color: theme.palette.primary.main
  },

  error: {
    top: '64px',
    color: theme.app.indication.danger,
    fontSize: '11px'
  },

  flexWidth: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& div': {
      width: '100%'
    }
  },

  btnFilter: {
    width: 48,
    height: 40,
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    backgroundColor: theme.palette.primary.main,
    border: 'none',
    color: theme.palette.text.primary,
    fontWeight: 600,
    marginTop: '4px'
  },

  formTitle: {
    color: theme.app.colors.text.primary,
    marginBottom: '16px',
    paddingBottom: '3px',
    width: '100%',
    lineHeight: '18px'
  },

  // checkControl: {
  //   display: 'flex',
  //   gap: '40px',
  //   marginBottom: '16px',

  //   [theme.breakpoints.down('sm')]: {
  //     flexDirection: 'column',
  //     gap: '10px',
  //   }
  // },

  check: {
    position: 'relative',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px'
    },
    '& input': {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: '1px'
    },

    '& label': {
      position: 'relative',
      paddingLeft: '28px',
      display: 'inline-block',
      cursor: 'pointer',
      color: '#232323',

      '&::before': {
        content: '""',
        border: `1px solid ${theme.app.colors.border.dark}`,
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '18px',
        width: '18px',
        background: '#FFF',
        marginRight: '0.5em',
        transition: 'all 0.2s ease',
        position: 'absolute',
        top: '50%',
        left: '0',
        transform: 'translate(0, -50%)',
        borderRadius: '3px'
      },

      '&::after': {
        content: '""',
        position: 'absolute',
        background: 'no-repeat center center',
        backgroundImage: `url(${checkImage})`,
        top: '50%',
        left: '0.65em',
        transform: 'translate(-50%, -50%)',
        color: '#FFF',
        opacity: '0',
        transition: 'all 0.2s ease',
        width: '18px',
        height: '18px'
      }
    },

    '& input:checked + label::after': {
      opacity: '1'
    },

    '& input:checked + label::before': {
      backgroundColor: theme.app.colors.border.dark
    }
  },

  customInputWrapper: {
    display: 'flex',
    marginBottom: 8,
    position: 'relative',
    flexDirection: 'column',

    '& .custom-input__label': {
      color: theme.app.colors.text.primary,
      fontSize: 14
    },
    '& .custom-input__input': {
      width: 'calc(100% - 16px)',
      margin: '8px 0 8px 0',
      height: 24,
      padding: 8,
      borderRadius: 4,
      backgroundColor: theme.app.colors.input.background,
      color: theme.app.colors.text.primary,
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      border: 'none',
      boxSizing: 'content-box',

      '&:focus': {
        outlineWidth: 0,
        border: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '-moz-appearance': 'textfield',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      }
    },

    '@media (min-width:961px)': {
      '& .custom-input__input': {
        display: 'flex'
      }
    }
  },

  '.error': {
    top: 64,
    position: 'absolute',
    color: theme.app.indication.danger,
    fontSize: theme.app.typography.error.fontSize
  },

  containerButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '16px',
    marginTop: '24px',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      gap: '10px',

      '& button': {
        width: '100%'
      }
    }
  }
}))
